// extracted by mini-css-extract-plugin
export default {"app":"DJUbyme___app","app-content":"gmvQv9P___app-content","appContent":"gmvQv9P___app-content","app-footer":"aFBUemw___app-footer","appFooter":"aFBUemw___app-footer"};